import request from "../util/request";

export const getBannerList = query => {
  // 首页banner图
  return request({
    url: '/bannerList.action',
    method: 'post',
    params: query,
  });
};

export const aboutEnList = query => {
  // 获取关于我们英文图片组
  return request({
    url: '/aboutEnList.action',
    method: 'post',
    params: query,
  });
};

// export const getAboutPageInfo = query => {
export const aboutZhList = query => {
  // 获取关于我们中文图片组
  return request({
    url: '/aboutZhList.action',
    method: 'post',
    params: query,
  });
};

export const webNewsList = query => {
  // 获取新闻列表
  return request({
    url: '/webNewsList.action',
    method: 'post',
    params: query,
  });
};

export const contactList = query => {
  // 获取联系我们页面列表
  return request({
    url: '/contactList.action',
    method: 'post',
    params: query,
  });
};

export const webProductList = query => {
  // 获取作品页面列表
  return request({
    url: '/webProductList.action',
    method: 'post',
    params: query,
  });
};

export const productEnPicList = query => {
  // 英文作品详情
  return request({
    url: '/productEnPicList.action',
    method: 'post',
    params: query,
  });
};

export const productZhPicList = query => {
  // 中文作品详情
  return request({
    url: '/productZhPicList.action',
    method: 'post',
    params: query,
  });
};

export const getProductWebInfo = query => {
  // 中文作品详情手机端
  return request({
    url: '/getProductWebInfo.action',
    method: 'post',
    params: query,
  });
};


export const webPublicationList = query => {
  // 获取报刊页面列表
  return request({
    url: '/webPublicationList.action',
    method: 'post',
    params: query,
  });
};

export const publicationPicsList = query => {
  // 获取刊物详情列表
  return request({
    url: '/publicationPicsList.action',
    method: 'post',
    params: query,
  });
};
